// components/UTMTracker.js

import { useEffect } from 'react';
import { getUTMParams } from 'src/core/lib/utm';
import { VITE_URL_API } from 'src/global-config';

const sendUTMToServer = async (utmData) => {
  try {
    await fetch(`${VITE_URL_API}/v1/track-utm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ meta: utmData }),
    });
  } catch (error) {
    console.error('Ошибка при отправке UTM:', error);
  }
};

const UTMTracker = () => {
  useEffect(() => {
    const utmData = getUTMParams();

    if (utmData) {
      sendUTMToServer(utmData);

      // Сохраняем в localStorage, если нужно использовать позже
      localStorage.setItem('utm_data', JSON.stringify(utmData));
    }
  }, []);

  return null;
};

export default UTMTracker;
